import { NgModule } from '@angular/core'
import { Routes } from '@angular/router'

export const customLibRoutes: Routes = []

@NgModule({
  declarations: [],
  imports: [
    // RouterModule.forChild(routes)
  ]
  // exports: [RouterModule]
})
export class CustomLibRoutingModule {}
